import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=8665d28a&scoped=true&"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=8665d28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8665d28a",
  null
  
)

export default component.exports